import { PublicClientApplication } from "@azure/msal-browser";
import getMsalConfig from "./msalConfig";

const msalInstance = new PublicClientApplication(getMsalConfig());

export default msalInstance;
